var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-toggle": true,
          "show-new": false,
          "show-delete": false,
          "show-save": false,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _c("parts-catalogue-side-menu", {
              on: { filter: _vm.filterList, reset: _vm.resetList },
              model: {
                value: _vm.filter,
                callback: function ($$v) {
                  _vm.filter = $$v
                },
                expression: "filter",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "tile is-parent" }, [
            _c(
              "article",
              { staticClass: "tile is-chile box" },
              [
                _c(
                  "bulma-table",
                  {
                    staticClass:
                      "table is-bordered is-striped is-narrow is-fullwidth",
                    attrs: {
                      columns: _vm.columns,
                      "page-index": _vm.filter.pageIndex,
                      "page-size": _vm.filter.pageSize,
                      "total-rows": _vm.totalRows,
                      "is-loading": _vm.isTableLoading,
                      "sort-column": _vm.filter.sortColumn,
                      "sort-order": _vm.filter.sortOrder,
                    },
                    on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                  },
                  [
                    _vm._l(_vm.entity, function (item, index) {
                      return _c(
                        "tr",
                        {
                          key: item.RowNumber,
                          class: { "is-selected": _vm.selectedRow === index },
                          on: {
                            click: function ($event) {
                              return _vm.highlightSelected(index, $event)
                            },
                          },
                        },
                        [
                          _c("td", [_vm._v(_vm._s(item.itemNo))]),
                          _c("td", [_vm._v(_vm._s(item.bodyID))]),
                          _c("td", [_vm._v(_vm._s(item.side))]),
                          _c("td", { staticClass: "has-text-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatCurrency(
                                  item.unitPrice,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]),
                          _c("td", [_vm._v(_vm._s(item.partDesc))]),
                          _c("td", [_vm._v(_vm._s(item.partNo))]),
                        ]
                      )
                    }),
                    _c("template", { slot: "empty" }, [
                      _c("section", { staticClass: "section" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "content has-text-grey has-text-centered",
                          },
                          [
                            _c("span", { attrs: { icon: "icon is-large" } }, [
                              _c("i", {
                                staticClass: "mdi mdi-48px mdi-emoticon-sad",
                              }),
                            ]),
                            _c("p", [_vm._v("Nothing")]),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }